import { render, staticRenderFns } from "./VideoImage.vue?vue&type=template&id=bdc33fa8&scoped=true"
import script from "./VideoImage.vue?vue&type=script&lang=js"
export * from "./VideoImage.vue?vue&type=script&lang=js"
import style0 from "./VideoImage.vue?vue&type=style&index=0&id=bdc33fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc33fa8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoImage.vue
// module id = 140
// module chunks = 0